import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
    selectIsBtnNewTableGrabEnabled,
    selectScale,
} from '../../../redux/diagram/diagram.selectors';

import './DraggableTable.scss';

export const DraggableTable = () => {
    const isBtnNewTableGrabEnabled = useSelector(
        selectIsBtnNewTableGrabEnabled
    );
    const scale = useSelector(selectScale);

    const [mouseXY, setMouseXY] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const handleDocumentMouseMove = (event) => {
            const mouseX = event.clientX - 160 * scale;
            const mouseY = event.clientY - 40 * scale;

            setMouseXY({ x: mouseX, y: mouseY });
        };

        document.addEventListener('mousemove', handleDocumentMouseMove);

        return () => {
            document.removeEventListener('mousemove', handleDocumentMouseMove);
        };
    }, [isBtnNewTableGrabEnabled, scale]);

    const tableElement = (
        <div
            className={`drag-element-table ${isBtnNewTableGrabEnabled && 'selected'
                }`}
            style={{
                left: `${mouseXY.x}px`,
                top: `${mouseXY.y}px`,
                width: `${320 * scale}px`,
                height: `${86.25 * scale}px`,
                borderRadius: `${5.5 * scale}px`,
                borderWidth: `${1.3 * scale}px`,
            }}
        >
            <div
                className="drag-element-table-header"
                style={{
                    height: `${41.25 * scale}px`,
                    borderTopLeftRadius: `${5.5 * scale}px`,
                    borderTopRightRadius: `${5.5 * scale}px`,
                    borderBottomWidth: `${1.3 * scale}px`,
                }}
            ></div>
        </div>
    );

    return (
        <div>
            {isBtnNewTableGrabEnabled && tableElement}
        </div>
    );
};

export default DraggableTable;
